import { render, staticRenderFns } from "./TgDocumentItem.vue?vue&type=template&id=277be1b6"
import script from "./TgDocumentItem.vue?vue&type=script&lang=js"
export * from "./TgDocumentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports